/* Form Page to edit a Profile */
import React, { useState, useEffect, useRef } from "react"
import { useHistory, useParams } from "react-router-dom"
import Form from "react-bootstrap/Form"
import Button from "react-bootstrap/Button"
import Image from "react-bootstrap/Image"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
import Alert from "react-bootstrap/Alert"

import { axiosInstance, axiosReq } from "../../api/axiosDefaults"
import {
  useCurrentUser,
  useSetCurrentUser,
} from "../../contexts/CurrentUserContext"
import {
  useSetQueryContext,
} from "../../contexts/ProfileDataContext";
import styles from "../../styles/Profile.module.css"
import btnStyles from "../../styles/Button.module.css"
import TopBox from "../../components/TopBox"
import toast from "react-hot-toast"

const MAX_FILE_SIZE_MB = 5
const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024

const ProfileEditForm = () => {
  // useRedirect()
  const currentUser = useCurrentUser()
  const { id } = useParams()
  const history = useHistory()
  const imageFile = useRef()
  const setQuery = useSetQueryContext();

  const [profileData, setProfileData] = useState({
    name: "",
    position: "",
    image: "",
    phone_number: "",
    email: "",
    username: "",
    call_time_username: "",
  })

  // const [name1, setName1] = useState({
  //   name: "",
  // })

  // const [phone1, setPhone1] = useState({
  //   phone_number: "",
  // })

  const { name, position, content, image, phone_number, call_time_username } = profileData;

  const [errors, setErrors] = useState({})

  useEffect(() => {
    /* Function to fetch a profile and set the profileData 
       to the data returned */
    const handleMount = async () => {
      // if (currentUser?.profile_id?.toString() === id) {
        try {
          // TODO: remove for client
          const { data } = await axiosInstance.get(
            `/${localStorage.getItem("projectSlug")}/profiles/${id}/`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
              },
              withCredentials: true,
            }
          )
          const { name, position, content, image, phone_number, call_time_username } = data
          // setName1(data.name)
          // setPhone1(data.phone_number)
          setProfileData({
            name,
            position,
            content,
            image,
            phone_number,
            call_time_username,
          })
        } catch (err) {
          history.push(`/${localStorage.getItem("projectSlug")}/signin`)
        }
      // } else {
      //   history.push(`/${localStorage.getItem("projectSlug")}/signin`)
      // }
    }

    handleMount()
  }, [currentUser, history, id])

  const handleChange = (event) => {
    setProfileData({
      ...profileData,
      [event.target.name]: event.target.value,
    })
  }

  const validateFileSize = (file, inputRef) => {
    if (file.size <= MAX_FILE_SIZE_BYTES) {
      return true
    }

    if (inputRef?.current) {
      inputRef.current.value = ""
    }

    toast.error(`Only ${MAX_FILE_SIZE_MB} MB files are allowed.`)
    return false
  }

  const handleSubmit = async (event) => {
    event.preventDefault()

    const selectedImage = imageFile?.current?.files[0]
    if (selectedImage && !validateFileSize(selectedImage, imageFile)) {
      return
    }

    const formData = new FormData()
    formData.append("name", name)
    formData.append("content", content)
    formData.append("position", position)
    formData.append("phone_number", phone_number)

    if (selectedImage) {
      formData.append("image", selectedImage)
    }

    try {
      await axiosInstance.put(
        `/${localStorage.getItem("projectSlug")}/profiles/${id}/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
          withCredentials: true,
        }
      )
      toast.success(`Profile Updated Successfully!`);
      setQuery(name)
      history.goBack()
    } catch (err) {
      setErrors(err.response?.data)
    }
  }

  return (
    <div>
      <TopBox title="Edit Profile" title2={`${name}`} />
      <Button
        onClick={() => history.goBack()}
        className={`${btnStyles.Button} ${btnStyles.Blue} my-2`}
      >
        Back
      </Button>
      <h5 className={`text-center py-1 mt-3 ${styles.SubTitle }`}>
           PROFILE EDIT FORM</h5> 
      <Form className={`${styles.White } px-3`} onSubmit={handleSubmit}>
        <Row className="mt-3">
          <Col md={6} className="text-center" >
          <Form.Group controlId="position" className="mb-2">
            <Form.Label className={`${styles.BoldScene}`}>Position</Form.Label>
            <Form.Control
            className={`${styles.Input}`}
              type="text"
              name="position"
              value={position}
              onChange={handleChange}
            />
          </Form.Group>
          {errors?.position?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          {/* <Form.Group controlId="content" className="mt-3">
            <Form.Label className={`${styles.BoldScene}`}>Additional Info</Form.Label>
            <Form.Control
            className={`${styles.InputScene}`}
              as="textarea"
              value={content}
              onChange={handleChange}
              name="content"
              rows={2}
            />
          </Form.Group>
          {errors?.content?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))} */}
          </Col>
          <Col className="text-center" md={4}>
          <p className={`${styles.BoldScene}`}>Profile Image</p>
            <div>
              <Form.Group>
                {image && (
                  <figure >
                    <Image 
                    className={`${styles.ImagesIndex}`}
                    src={image} />
                  </figure>
                )}
                {errors?.image?.map((message, idx) => (
                  <Alert variant="warning" key={idx}>
                    {message}
                  </Alert>
                ))}
                <div>
                  <Form.Label
                    className={`${btnStyles.Button} ${btnStyles.GreyDark} my-auto`}
                    htmlFor="image-upload"
                  >
                    Change the image
                  </Form.Label>
                </div>
                <Form.Control
                  type="file"
                  id="image-upload"
                  ref={imageFile}
                  accept="image/*"
                  onChange={(e) => {
                    if (!e.target.files.length) {
                      return
                    }
                    const file = e.target.files[0]
                    if (!validateFileSize(file, imageFile)) {
                      return
                    }
                    if (image?.startsWith?.("blob:")) {
                      URL.revokeObjectURL(image)
                    }
                    setProfileData({
                      ...profileData,
                      image: URL.createObjectURL(file),
                    })
                  }}
                />
              </Form.Group>
            </div>
          </Col>
        </Row>
        <Row className="text-center mt-3">
        <Col className="mt-3">
          <Button
            className={`${btnStyles.Button} ${btnStyles.Blue} mr-3 px-3 px-md-5`}
            onClick={() => history.goBack()}
          >
            Cancel
          </Button>
          <Button
            className={`${btnStyles.Button} ${btnStyles.Blue} ml-3 px-3 px-md-5`}
            type="submit"
          >
            Submit
          </Button>
        </Col>
      </Row>
      </Form>
      <Row className="mt-3">
        <Col xs={12} md={8}>
          <Row className="mb-1">
            <Col xs={4} md={3}>
              <p className={`${styles.BoldScene} text-nowrap`}>User</p>
            </Col>
            <Col xs={8} md={9}>
              <p className="mb-0">{currentUser?.username}</p>
            </Col>
          </Row>
          <Row className="mb-1">
            <Col xs={4} md={3}>
              <p className={`${styles.BoldScene} text-nowrap`}>Call time</p>
            </Col>
            <Col xs={8} md={9}>
              <p className="mb-0 text-break">
                {call_time_username || currentUser?.call_time_username}
              </p>
            </Col>
          </Row>
          <Row className="mb-1">
            <Col xs={4} md={3}>
              <p className={`${styles.BoldScene} text-nowrap`}>Name</p>
            </Col>
            <Col xs={8} md={9}>
              <p className="mb-0">{name}</p>
            </Col>
          </Row>
          <Row className="mb-1">
            <Col xs={4} md={3}>
              <p className={`${styles.BoldScene} text-nowrap`}>Mobile</p>
            </Col>
            <Col xs={8} md={9}>
              <p className="mb-0">{phone_number}</p>
            </Col>
          </Row>
          <Row className="mb-1">
            <Col xs={4} md={3}>
              <p className={`${styles.BoldScene} text-nowrap`}>Email</p>
            </Col>
            <Col xs={8} md={9}>
              <p className="mb-0 text-break">{currentUser?.email}</p>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  )
}

export default ProfileEditForm
